import * as TYPES from '../types';

const initialState = {
    eventList: [],
};

export function EventReducer(state = initialState, action) {
    const preState = { ...state };
    const { type, payload } = action;
    switch (type) {
        case TYPES.GET_ALL_EVENTS_SUCCESS:
            return {
                ...preState,
                eventList: payload,
            };

        default:
            return state;
    }
}